"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productCard.name': 'Scheda Prodotto',
};
